__turbopack_context__.v({
  "chapter": "Yc9EyW_chapter",
  "container": "Yc9EyW_container",
  "content": "Yc9EyW_content",
  "info": "Yc9EyW_info",
});
